<template>
  <div class="billing-report-page">
    <h6>Relatório de agendamentos por marcadores</h6>
    <div class="columns" style="margin-bottom: 1rem;">
      <div class="column col-6 col-md-6 col-sm-12 form-group"
           :class="{'has-error': $v.filters.startDate.$error || $v.filters.endDate.$error}">
        <label class="form-label">Período</label>
        <st-date-period
          :start-date.sync="filters.startDate"
          :end-date.sync="filters.endDate"
          :start-date-validator="$v.filters.startDate"
          :end-date-validator="$v.filters.endDate"
          @blur:startDate="$v.filters.startDate.$touch()"
          @blur:endDate="$v.filters.endDate.$touch()"
        />
      </div>
    </div>
    <div class="billing-list" style="height: 15rem">
      <div class="scroll-list-wrapper">
        <div class="scroll-list">
          <div class="list-header">
            <label class="form-checkbox">
              <input type="checkbox"
                     @change="selectAllMarkers"
                     :checked="getMarkersSelected"
                     :indeterminate.prop="getMarkersSelected === null">
              <i class="form-icon"></i>
            </label>
            <div class="list-title">Marcadores</div>
          </div>
          <table class="table table-hover">
            <tbody>
            <tr v-for="(item, i) in markers" :key="i">
              <td width="30px">
                <label class="form-checkbox">
                  <input type="checkbox" v-model="item.selected">
                  <i class="form-icon"></i>
                </label>
              </td>
              <td>{{ item.name }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="footer">
      <button class="btn btn-primary btn-icon-left"
              :class="{loading: printing}"
              :disabled="printing"
              @click="print">
        <fa-icon :icon="['fal', 'print']"></fa-icon>Imprimir
      </button>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { required } from 'vuelidate/lib/validators';
import { date, minDate } from '@/data/validators';
import formMixin from '@/mixins/form';

export default {
  mixins: [formMixin],
  data() {
    return {
      printing: false,
      markers: [],
      filters: {
        startDate: '',
        endDate: '',
      },
    };
  },
  validations() {
    const rules = {
      filters: {
        startDate: { date, required },
        endDate: { date, required },
      },
    };
    if (this.filters.startDate) {
      rules.filters.endDate = {
        date,
        required,
        minDate: minDate(this.filters.startDate),
      };
    }

    return rules;
  },
  mounted() {
    this.filters.startDate = moment()
      .startOf('month')
      .format('YYYY-MM-DD');
    this.filters.endDate = moment()
      .endOf('month')
      .format('YYYY-MM-DD');
    this.loadMarkers();
  },
  computed: {
    getMarkersSelected() {
      if (!this.markers || this.markers.length === 0) {
        return false;
      }

      const selected = this.markers.filter(item => item.selected);
      if (selected.length === 0) {
        return false;
      }
      if (selected.length === this.markers.length) {
        return true;
      }
      return null;
    },
  },
  methods: {
    selectAllMarkers(e) {
      this.markers.forEach((item) => {
        item.selected = e.target.checked;
      });
    },
    loadMarkers() {
      const params = {
        active: true,
      };
      return this.$http.get('/markers', { params })
        .then(({ data }) => {
          this.markers = data.items.map(item => ({
            id: item.id,
            name: item.name,
            selected: true,
          }));
        })
        .catch(() => {});
    },
    print() {
      this.$v.filters.$touch();
      if (this.$v.filters.$error) {
        return false;
      }

      const diff = moment(this.filters.endDate)
        .diff(moment(this.filters.startDate), 'months');

      if (diff > 6) {
        this.$toast.show('Período máximo (6 meses)', { type: 'error' });
        return null;
      }

      this.printing = true;

      const params = {
        startDate: this.filters.startDate,
        endDate: this.filters.endDate,
      };

      if (this.getMarkersSelected === null) {
        params.markerIds = this.markers
          .filter(({ selected }) => selected)
          .map(item => item.id).join(',');
      }

      return this.$file
        .print('/appointments/print-markers', params)
        .catch(() => {})
        .then(() => {
          this.printing = false;
        });
    },
  },
};
</script>

<style lang="scss">
  @import "../../../assets/scss/variables";
  @import '~assets/scss/mixins';
  .billing-report-page {
    .billing-list {
      display: flex;
      flex-direction: column;
      height: 40rem;
      overflow-y: auto;
      .list-header {
        align-items: center;
        border-bottom: $border-width solid $border-color;
        display: flex;
        padding-bottom: $layout-spacing;
        .list-title {
          flex: 1;
          font-weight: bold;
        }
      }
      .scroll-list-wrapper {
        border: $border-color solid $border-width;
        border-radius: $border-radius;
        flex-grow: 1;
        margin-bottom: $layout-spacing-lg * 2;
        position: relative;
      }
      .scroll-list {
        bottom: 0;
        overflow-y: auto;
        padding: $layout-spacing $layout-spacing-lg;
        position: absolute;
        top: 0;
        width: 100%;
        @include scroll-bar();
        .table th, .table td {
          padding: 0;
        }
        .table td {
          border-bottom: none;
        }
      }
    }
    .footer {
      text-align: right;
    }
  }
</style>
